import React from 'react'

function Footer() {

    const year = new Date().getFullYear()

    return (
        <footer className="bg-primary text-white">
            <div className="p-5 ">
                <div className="container">
                    <div className="row text-center">
                        <div className="col-md-4">
                            <i class="fab fa-app-store-ios fa-3x"></i>
                        </div>
                        <div className="col-md-4">
                            <i class="fas fa-wifi fa-3x"></i>
                        </div>
                        <div className="col-md-4">
                            <i class="fab fa-app-store-ios fa-3x"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-primary">
                <div className="footer-copyright text-center py-3">© {year} Copyright:
                    <a href="https://progitek.no/"> Ole Petter Kyrkjebø Hjønnevåg</a>
                </div>
            </div>

        </footer>

    )
}
export default Footer